import { BaseEntity } from '../base-entity';
import { Report } from './report';
import { UserPrincipal } from './user-principal';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
import { AuthzContextsActionMap, CrudAction } from '@mri-platform/resource-authz';
/// </code-import>

export interface ReportUserPreference {
  userId: string;
  reportId: string;
  isDefault: boolean;
  isFavorite: boolean;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  periodEnd: Date;
  periodStart: Date;
  tenantKey: string;
  report: Report;
  user: UserPrincipal;
}

/// <module-code> Place module level code between <module-code> tags
export enum ReportUserPreferenceCustomAction {
  Upsert = 'Upsert'
}
/// </module-code>

export class ReportUserPreference extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static authorization = {
    ...AuthzContextsActionMap.crudFor(EntityName.ReportUserPreference),
    [ReportUserPreferenceCustomAction.Upsert]: {
      action: [CrudAction.Create, CrudAction.Update],
      resource: EntityName.ReportUserPreference
    }
  };
  /// </code>
  // Generated code. Do not place code below this line.
}
